<p-table [paginator]="true" [rows]="10" [showCurrentPageReport]="true" responsiveLayout="scroll"
styleClass="p-datatable-striped"[responsive]="true" [columns]="column"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [value]="contractReport"
    [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [lazyLoadOnInit]="false" [totalRecords]="totalRecords"
    [rowsPerPageOptions]="[10,25,50]" dataKey="index">

    <ng-template pTemplate="header" let-columns>
        <tr style="word-break: break-word;">
            <th style="width: 3em;"></th>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="font-bold">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-contractReport let-expanded="expanded" let-rowIndex="rowIndex">
        <tr>
            <td>
                <button type="button" pButton pRipple [pRowToggler]="contractReport"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td>{{contractReport.contractId}}</td>
            <td>{{contractReport.partnerId}}</td>
            <td>{{contractReport.pac}}</td>
            <td>{{contractReport.productCode}}</td>
            <td *ngIf="contractReport.activationCount === 1">Yes</td>
            <td *ngIf="contractReport.activationCount !== 1">No</td>
            <td>{{contractReport.transactionDateTime | date: 'MMM dd yyyy HH:mm'}}</td>
            <td>{{contractReport.activationStartDatetime | date: 'MMM dd yyyy HH:mm'}}</td>
            <td>{{contractReport.activationEnddate | date: 'MMM dd yyyy HH:mm'}}</td>
        </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-rowData let-columns="column">
        <tr>
            <td colspan="7" [attr.colspan]="column.length + 2" class="table-td">
                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Service Name
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.serviceLevelName}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Service Coverage
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.serviceCoverage}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Market Sector
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.marketSectorName}}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Contract Duration
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.contractDuration}} {{rowData.contractDurationUnit}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Status
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.status}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Geogating Mode :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.geogatingMode}}
                            </div>
                        </div>
                    </div>
                </div>


                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Partner Name
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.organizationDisplayName}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Beam
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.beams}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid">

                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Old PAC
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.oldPac}}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Renewal
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.isRenewal}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid">

                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Latitude
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.lat}}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Edited
                                    :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                               <span *ngIf="rowData.dateOfEdit !== undefined">Yes</span>
                               <span *ngIf="rowData.dateOfEdit == undefined">No</span>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div class="grid"> 
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Longitude :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.longitude}}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Partner Reference :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.partnerRef}}
                            </div>
                        </div>
                    </div>
                </div>

                     
                <div class="grid"> 
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Date of Edit :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.dateOfEdit | date: 'MMM dd yyyy HH:mm'}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Field 2 :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.field2}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid"> 
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Field 1 :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.field1}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Field 3  :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.field3}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid"> 
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-5" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Country Code :</label>
                            </div>
                            <div class="col-7 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.countryCode}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                        <div class="grid" style="align-items: center;">
                            <div class="col-6" style="text-align: right">
                                <label for="pac" class="lbl-fontfamily">Date of PAC Transfer (UTC):</label>
                            </div>
                            <div class="col-6 data-fontfamily" style="text-align:left;vertical-align: middle">
                                {{rowData.dateOfTransfer | date: 'MMM dd yyyy HH:mm'}}
                            </div>
                        </div>
                    </div>
                </div>

            </td>
        </tr>
    </ng-template>
</p-table>